/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import { createSelector } from "reselect";

// --- for Notes ---
// ----------------------------------------------------------------------

// Function to retrieve piece of state
const dataLectureId = (state: any, props: any) => props.lecture;
const dataNotes = (state_notes: any) => state_notes;

// Selector consumed by components consuming
export const selectorNotes = createSelector([dataNotes], (notes) => notes);

// Selector consumed by action creator to check if the notes of requested lecture is loaded
// Usage:  lecNotesLoaded(piece_of_state, props)
// Example: if (lecNotesLoaded(getState(), { lecture: lec_id }))
//
// [dataLectureId, dataNotes] are two functions that retrieve...
//  1. 'lecture' from props, as requested_lecture
//  2. notes from state, as notes
// In this case, we returns true/false only
export const lecNotesLoaded = createSelector(
  [dataLectureId, dataNotes],
  (requested_lecture, notes) => notes[requested_lecture] !== undefined,
);

// --- for LecsWithNotes ---
// ----------------------------------------------------------------------

// Function to retrieve piece of state
const courseId = (state: any, props: any) => props.course;
const dataLecsWithNotes = (state_notes: any) => state_notes.lecsWithNotes;

// Selector consumed by components consuming
export const selectorLecsWithNotes = createSelector(
  [dataLecsWithNotes],
  (lecsWithNotes) => lecsWithNotes,
);

// Selector consumed by action creator to check if the lecsWithNotes is loaded
export const lecsWithNotesLoaded = createSelector(
  [courseId, dataLecsWithNotes],
  (courseRequested_id, lecsWithNotes) =>
    lecsWithNotes && lecsWithNotes.course === courseRequested_id,
);
